import {useLocation} from 'react-router-dom'
import {canonicalPath, landingPages} from '../Seo/siteContent'
import './LandingContent.scss'

export default function LandingContent() {
    const path = canonicalPath(useLocation().pathname)
    const page = landingPages[path]
    const routeLinks = [
        {href: '/routes/voronezh-moskva/', label: 'Воронеж — Москва и обратно', city: '/voronezh/'},
        {href: '/routes/rossosh-moskva/', label: 'Россошь — Москва и обратно', city: '/rossosh/'},
        {href: '/routes/boguchar-moskva/', label: 'Богучар — Москва и обратно', city: '/boguchar/'},
        {href: '/routes/kpp-bugaevka-moskva/', label: 'КПП Бугаевка — Москва и обратно', city: '/bugaevka/'}
    ].filter(route => path === '/' || route.city === path)
    if (!page) return null
    return <section className="LandingContent" aria-labelledby="trip-planning-title">
        <div className="LandingContent__intro">
            <p className="LandingContent__eyebrow">Планирование поездки</p>
            <h2 id="trip-planning-title">{page.heading}</h2>
            <p>{page.intro}</p>
        </div>
        <div className="LandingContent__cards">
            {page.sections.map(section => <article key={section.heading}>
                <h3>{section.heading}</h3>
                <p>{section.text}</p>
            </article>)}
        </div>
        {routeLinks.length > 0 && <nav className="LandingContent__directions" aria-labelledby="route-directions-title">
            <h2 id="route-directions-title">Междугородние маршруты</h2>
            <p>Откройте нужное направление, сравните классы и уточните детали поездки.</p>
            <ul>{routeLinks.map(route => <li key={route.href}><a href={route.href}><span>{route.label}</span><small>Калькулятор стоимости и условия поездки</small><span className="LandingContent__arrow" aria-hidden="true">↗</span></a></li>)}</ul>
        </nav>}
        <nav className="LandingContent__directions" aria-labelledby="directions-title">
            <h2 id="directions-title">{path === '/' ? 'Города и пункты отправления' : 'Другие направления Флики'}</h2>
            <p>{path === '/' ? 'Выберите раздел, чтобы уточнить детали поездки из нужного города или от КПП.' : 'Если поездка начинается в другом месте, перейдите в соответствующий раздел.'}</p>
            <ul>{page.related.map(href => <li key={href}>
                <a href={href}><span>{landingPages[href].label}</span>{landingPages[href].region && <small>{landingPages[href].region}</small>}<span className="LandingContent__arrow" aria-hidden="true">↗</span></a>
            </li>)}</ul>
        </nav>
    </section>
}
